// Centralized brand assets for the Zodiac Workforce Intelligence Institute.
// Update here to roll new seals across the entire ecosystem.

export const OFFICIAL_SEAL =
  "https://customer-assets.emergentagent.com/job_88d281f7-bb96-4c9e-b96f-7ca8aaa7f9b2/artifacts/cq17yq0o_image.png";

export const FOUNDER_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_88d281f7-bb96-4c9e-b96f-7ca8aaa7f9b2/artifacts/1ggn816l_Profile%20Picture.png";

export const INSTITUTE_NAME = "Zodiac Workforce Intelligence Institute";
export const INSTITUTE_SHORT = "Zodiac Institute";
